function checkDataType(payload) {
  const map = {
    '[object String]': 'string',
    '[object Object]': 'object',
    '[object Array]': 'array',
    '[object Number]': 'number',
    '[object Boolean]': 'boolean',
    '[object Null]': 'null',
    '[object Undefined]': 'undefined',
    '[object Function]': 'function',
    '[object Error]': 'error',
    '[object Symbol]': 'symbol',
    '[object RegExp]': 'regexp'
  }
  const t = Object.prototype.toString.call(payload)
  return map[t]
}
/**
 * Add the object as a parameter to the URL
 * @param baseUrl url
 * @param obj
 * @returns {string}
 * eg:
 *  let obj = {a: '3', b: '4'}
 *  setObjToUrlParams('www.baidu.com', obj)
 *  ==>www.baidu.com?a=3&b=4
 */
export function setObjToUrlParams(baseUrl, obj = {}) {
  let parameters = ''
  for (const key in obj) {
    if (obj[key]) parameters += key + '=' + encodeURIComponent(obj[key]) + '&'
  }
  parameters = parameters.replace(/&$/, '')
  return /\?$/.test(baseUrl) ? baseUrl + parameters : baseUrl.replace(/\/?$/, '?') + parameters
}

function debounce(fn, delay = 500) {
  if (checkDataType(fn) !== 'function') {
    console.error(`${fn} is not a function`)
    return false
  }
  let timer = null
  return function () {
    if (timer) clearTimeout(timer)
    timer = setTimeout(() => {
      fn.apply(this, arguments)
      timer = null
    }, delay)
  }
}

function throttle(fn, delay = 300) {
  if (checkDataType(fn) !== 'function') {
    console.error(`${fn} is not a function`)
    return false
  }
  let timer = null
  return function () {
    if (timer) return
    timer = setTimeout(() => {
      fn.apply(this, arguments)
      timer = null
    }, delay)
  }
}

export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'shallow clone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  for (const keys in source) {
    if (source.hasOwnProperty(keys)) {
      if (source[keys] && typeof source[keys] === 'object') {
        targetObj[keys] = source[keys].constructor === Array ? [] : {}
        targetObj[keys] = deepClone(source[keys])
      } else {
        targetObj[keys] = source[keys]
      }
    }
  }
  return targetObj
}

function unique(arr, key) {
  const map = new Map()
  return arr.filter(item => {
    return !map.has(item[key]) && map.set(item[key], 1)
  })
}
function es6Unique(arr) {
  return Array.from(new Set(arr))
}
// 手机号脱敏
function encryptMobile(val = '') {
  val = val.toString()
  const reg = /(\d{3})\d*(\d{4})/
  return val.replace(reg, '$1****$2')
}

/*
 * @info 给定开始, 结束的时间戳, 返回开始到结束时间的倒计时
 * @param start {Number} 开始时间戳
 * @param end {Number} 结束时间戳
 * @param type {String} s秒  ms毫秒
 * @return {Object} {day, hour, minute, second}
 * */
function getCountDownTime(start, end, type = 's') {
  const diff = end - start
  const num = type === 's' ? 1 : 1000
  if (diff < 0) {
    return {
      day: 0,
      hour: '00',
      minute: '00',
      second: '00'
    }
  }
  const day = Math.floor(diff / num / 3600 / 24)
  const h = Math.floor((diff / num / 3600) % 24)
  const m = Math.floor((diff / num / 60) % 60)
  const s = Math.floor((diff / num) % 60)
  const hour = h > 9 ? h : `0${h}`
  const minute = m > 9 ? m : `0${m}`
  const second = s > 9 ? s : `0${s}`
  return {
    day,
    hour,
    minute,
    second
  }
}

function twoDecimal(num) {
  var result = parseFloat(num)
  if (isNaN(result)) {
    return 0
  }
  result = Math.round(num * 100) / 100
  var s_x = result.toString()
  return s_x
}

export function formatDate(date, showDay, append = '-') {
  if (!date) return date
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()
  if (month < 10) {
    month = '0' + month
  }
  if (day < 10) {
    day = '0' + day
  }
  if (showDay) {
    return year + append + month + append + day
  } else {
    return year + append + month
  }
}

/*
 * @info 获取天数时间戳
 * @param daycount {Number} 天数
 * */
function getDayStamp(daycount) {
  return 24 * 3600 * 1000 * daycount
}

/*
@return {object} {startTime: Date, endTime: Date}
1）今日：当前日期的数据总和。
2）昨日：昨天的数据总和。
3）本周：以星期一为一周的开始，星期日为一周的结束，显示星期一到当天的日期时间段的数据总和。
4）本月：显示当月1号到当天的日期时间段的数据总和。
5）今年：显示今年1月到当前月份的日期时间段的数据总和。
6）全部时间：从系统记录的第一个时间记录开始，到当前时间的数据总和。
*/
function computedTime(type) {
  let startTime, endTime
  let date = new Date()
  let year = date.getFullYear()
  let month = date.getMonth()
  let week = date.getDay()
  let curStamp = new Date().getTime()
  switch (type) {
    case 'today': // 今天
      startTime = endTime = new Date()
      break
    case 'yesterday': // 昨天
      startTime = endTime = new Date(curStamp - getDayStamp(1))
      break
    case 'curWeek': // 本周
      endTime = new Date()
      startTime = new Date(curStamp - getDayStamp(week === 0 ? 6 : week - 1))
      break
    case 'preWeek': // 上周
      const today = new Date()
      const lastWeek = new Date(today)
      lastWeek.setDate(lastWeek.getDate() - 7)

      startTime = new Date(lastWeek)
      startTime.setDate(startTime.getDate() - lastWeek.getDay() + 1)

      endTime = new Date(startTime)
      endTime.setDate(endTime.getDate() + 6)
      break
    case 'curMonth': // 本月
      startTime = new Date(year, month, 1)
      endTime = new Date()
      break
    case 'preMonth': // 上月
      year = month - 1 >= 0 ? year : year - 1
      month = month - 1 >= 0 ? month - 1 : 11
      startTime = new Date(year, month, 1)
      endTime = new Date(year, month, new Date(year, month + 1, 0).getDate())
      break
    case 'recentSixtyDay': // 近60天
      startTime = new Date(curStamp - getDayStamp(60))
      endTime = new Date()
      break
    case 'recentThirtyDay': // 近30天
      startTime = new Date(curStamp - getDayStamp(30))
      endTime = new Date()
      break
    case 'recentFifteenDay': // 近15天
      startTime = new Date(curStamp - getDayStamp(15))
      endTime = new Date()
      break
    case 'curYear': // 今年
      startTime = new Date(year, 0, 1)
      endTime = new Date()
      break
    case 'preYear': // 去年
      startTime = new Date(year - 1, 0, 1)
      endTime = new Date(year - 1, 11, 31)
      break
    case 'all': // 全部时间 (不用传,后台会计算)
      startTime = ''
      endTime = ''
      break
    default:
      break
  }
  return {
    startDate: formatDate(startTime, true),
    endDate: formatDate(endTime, true)
  }
}

export function formatSimpleDate(date) {
  if (!date) return date
  date = new Date(date)
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()
  return year + '年' + month + '月' + day + '日'
}

export const formatterCalendar = (day, isSelected) => {
  const month = day.date.getMonth() + 1
  const date = day.date.getDate()
  const cYear = new Date().getFullYear()
  const cMonth = new Date().getMonth() + 1
  const cDate = new Date().getDate()
  if (month === cMonth && date === cDate) {
    day.bottomInfo = '今天'
    if (!isSelected) day.className = 'today'
  }
  return day
}

export const transPxToRem = size => {
  return (0.026667 * 1000000 * size) / 1000000 + 'rem'
}

export function changeNumToHan(num) {
  var arr1 = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  var arr2 = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿']
  if (!num || isNaN(num)) {
    return '零'
  }
  var english = num.toString().split('')
  var result = ''
  for (var i = 0; i < english.length; i++) {
    var des_i = english.length - 1 - i //倒序排列设值
    result = arr2[i] + result
    var arr1_index = english[des_i]
    result = arr1[arr1_index] + result
  }
  //将【零千、零百】换成【零】 【十零】换成【十】
  result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十')
  //合并中间多个零为一个零
  result = result.replace(/零+/g, '零')
  //将【零亿】换成【亿】【零万】换成【万】
  result = result.replace(/零亿/g, '亿').replace(/零万/g, '万')
  //将【亿万】换成【亿】
  result = result.replace(/亿万/g, '亿')
  //移除末尾的零
  result = result.replace(/零+$/, '')
  //将【零一十】换成【零十】
  //result = result.replace(/零一十/g, '零十');//貌似正规读法是零一十
  //将【一十】换成【十】
  result = result.replace(/^一十/g, '十')
  return result
}

export function chunkArray(array, size) {
  let result = []
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size))
  }
  return result
}

const utils = {
  chunkArray,
  checkDataType,
  debounce,
  throttle,
  deepClone,
  encryptMobile,
  getCountDownTime,
  twoDecimal,
  getDayStamp,
  computedTime,
  unique,
  es6Unique
}

export default utils
